var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "url(#pattern0_24_685)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_24_685",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_24_685",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_24_685",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAAA4tJREFUeF7t3b2O00AQB/BZkxoJyYodXgBBC0jQnwTibSgpEBQUV/EoiBIEoqAB8SA4jlxFootuIVyiy5fj3fWsd9b7Tz12JvPzrHfXyZ0ivERVQInKBskQQIRdBAABiLAKCEsHHQIQYRUQlg46BCDCKmCYznQ6fboOXSwWPwwPcQpDhxiUbY2RZdknIrqllHpRVdV3g8OcQgDSUbYdjNub0D8+UQByBuQExjbaGwpAWkDOYHhFAcgJEAMMbygAOQCxwPCCApAdEAcMdhSAbEraA4MVBSBExIDBhgIQIlWW5S8ieuS0kjs+aHl1dfXcdUUPkOsOKbIs+0ZED5hQnNcpALm5h4hAAcj+LCs4CkCO1yFBUQByeqAEDCUZkDzPZ03TVKY37TzP704mk/WN/p7pMR1xRrOvJEBms9lDrfUXpdT7qqremRaYefa11Fo/q+v657n3Hz3IFoOI7qwLoZR6HQDFCON/fqZXS4xxhxjbzzAwijHGqEHaMAZGscIYLUgXxkAo1hijBDHF8IzihDE6EFsMTyjOGKMCccVgRumFMRoQrucZPWdfvTFGAcKF0bNTPmqtX3Yt+kyWDlGvQ4qieKKU+kxE2y+xmXzmzhit9au6ri87A28C1nXUFvGtodGCcHfGYYVshy8OjGiHLN8YrsMXB0p0HTIURiiUqECGxgiBEg1IKIyhUaIACY2xQVmuVqv7TdP85rhXtJ1DPIgUDJOHSxxQokFSwxA97U0RQyxIqhgiQVLGEAeSOoYoEGBcz9FEzLKAsb9tzDF9dj4HMPZLF7RDgHF8HQcDAcbpQSUICDDaR/jBQYBx/nY7KAgwuuc+g4EAoxtjsHUIMMwwBgEBhjmGdxBg2GF4BQGGPYY3EGC4YXgBAYY7BjsIMPphsIIAoz8GGwgweDBYQIDBh9EbBBi8GL1AgMGP4QwCDD8YTiBlWT4moq/cPyOz/IhGf1nH8pwiwq2338uyfPvv93RvAmbP8mvXgPmffevYQEaN4TpkheqQ0WPEBJIERiwgyWDEAJIUhnSQ5DAkgySJIRUkWQyJIEljSANJHkMSCDA2GyoStk6AsbO7FRoEGAdbjSFBgHFi3zcUCDBaNuGtQYqiuFBKXfR8nvBhPp+v/xEXXn2HLFTQbwWsO8RvOjg7QIRdAwABiLAKCEsHHQIQYRUQlg46BCDCKiAsHXQIQIRVQFg66BBhIH8BiprVg3afpk8AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.a83a783bb8df68a48b5d1fbb316b83b0.svg";
export { ForwardRef as ReactComponent };